export module Utils {
    
    //Helper function to get valid default value for dates. Transform back to date by taking output of this function (new Date(output)).
    export function dateToValidString(date: Date): string {
        return date.toISOString().slice(0,10); // return YYYY-MM-DD
    }
}